var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container solicitarPermuta" }, [
    _c(
      "div",
      { staticClass: "card" },
      [
        _vm.cadastroJson
          ? _c("cadastro-sicarf-retificacao", {
              attrs: {
                titleCadastro: "Retificação de Cadastro",
                routeName: "retificacao",
                cadastroJson: _vm.cadastroJson,
                cadastroEmpty: _vm.empty,
                tabs: _vm.tabs
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ed404fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ed404fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/receptor/retificacao/Cadastro.vue
// module id = null
// module chunks = 